import type { EquipmentAccessorialType } from './constants.ts'
import { createEquipmentCategory } from './internal.ts'

const dryVanAccessorials: EquipmentAccessorialType[] = [
  'load-bars',
  'straps',
  'food-grade',
  'e-track',
  'team-driver',
  'liftgate',
  'tanker-endorsement',
]
export const dryVanEquipment = createEquipmentCategory(
  {
    bucket: 'dry-van',
    mode: 'truckload',
    workflows: ['truckload'],
    accessorialTypes: dryVanAccessorials,
  },
  [
    { key: 'dry-van-53', name: "Dry van 53'" },
    { key: 'dry-van-48', name: "Dry van 48'" },
  ],
)
